export const DEFAULT_ROWS_PER_PAGE = 10;
